import { env } from './config/env';
import { mountWidget } from './widget/mount';

/**
 * Standalone entry point (Phase-1 demo / dev harness). Mounts the widget into
 * its host element, creating one if the page didn't provide it — the same call
 * a storefront embed snippet would make.
 */
const HOST_ID = 'sophia-ai-root';

const host = document.getElementById(HOST_ID) ?? createHost();

mountWidget(host, env.VITE_API_BASE_URL);

function createHost(): HTMLElement {
  const element = document.createElement('div');
  element.id = HOST_ID;
  document.body.appendChild(element);

  return element;
}
